import { gql } from "apollo-boost";

export const JOURNAL_AUTOCOMPLETE = gql`
  query($searchJournal: SearchJournalDto!) {
    searchJournal(searchJournalDto: $searchJournal) {
      results {
        title
        nImpactFactor
        id
      }
      count
    }
  }
`;

export const JOURNAL_SEARCH = gql`
  query($searchJournal: SearchJournalDto!) {
    searchJournal(searchJournalDto: $searchJournal) {
      results {
        id
        title
        nImpactFactor
        medlineTitleAbbr
        impactFactors {
          year
          ifNumber
        }
        publisherName
        issn
        country
        websites
        id
        nlmid
        categories
        meshes {
          name
        }
        history {
          start
          end
        }
      }
      count
    }
  }
`;

export const JOURNAL_ALL = gql`
  query($page: Int, $size: Int) {
    allJournal(page: $page, size: $size) {
      results {
        id
        title
        nImpactFactor
        medlineTitleAbbr
        impactFactors {
          year
          ifNumber
        }
        publisherName
        issn
        country
        websites
        id
        nlmid
        categories
        meshes {
          name
        }
        history {
          start
          end
        }
      }
      count
    }
  }
`;

export const JOURNAL_PAGE = gql`
  query($id: String!) {
    getJournal(id: $id) {
      id
      journal {
        id
        title
        issn
        nImpactFactor
        medlineTitleAbbr
        impactFactors {
          year
          ifNumber
        }
        publisherName
        publisherAddress
        country
        websites
        nlmid
        history {
          start
          end
        }
        meshes {
          name
        }
        categories
      }
    }
  }
`;
